import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import Chevron from 'svg/chevron-right.svg';
import styles from './Nav.pcss';
const Nav = ({ currentIndex, onIndexChange, measurmentsCount, label })=>{
    useStyles(styles);
    const onChangeIndex = (newIndex)=>{
        onIndexChange(newIndex);
    };
    const onNavClickHandler = (e)=>{
        if (!(e.currentTarget instanceof HTMLDivElement)) {
            return;
        }
        const { direction } = e.currentTarget.dataset;
        switch(direction){
            case 'prev':
                {
                    if (currentIndex - 1 < 0) {
                        onChangeIndex(measurmentsCount - 1);
                    } else {
                        onChangeIndex(currentIndex - 1);
                    }
                    break;
                }
            case 'next':
                {
                    if (currentIndex + 1 > measurmentsCount - 1) {
                        onChangeIndex(0);
                    } else {
                        onChangeIndex(currentIndex + 1);
                    }
                    break;
                }
            default:
                onChangeIndex(0);
        }
    };
    const renderButton = (direction, classes = '')=>/*#__PURE__*/ _jsx("div", {
            onKeyDown: onNavClickHandler,
            "data-direction": direction,
            onClick: onNavClickHandler,
            className: cn(styles.nav__navbutton, classes),
            children: /*#__PURE__*/ _jsx(Chevron, {})
        });
    return /*#__PURE__*/ _jsxs("nav", {
        className: styles.nav,
        children: [
            renderButton('prev', styles['nav__navbutton--left']),
            /*#__PURE__*/ _jsx("div", {
                className: styles.nav__label,
                children: label
            }),
            renderButton('next')
        ]
    });
};
export default Nav;
